<template lang="html">
  <div>
    <el-cascader placeholder="请选择" @change="handleChange" v-model="pointerId" :props="prop" :options="treeList" filterable change-on-select style="width:400px;">
    </el-cascader>
    <p style="margin:10px 0">注：所属区划决定了备案流程，请确定后操作</p>
  </div>
</template>
<script>
import account from '../../data/basic/plan/company.js'
export default {
  data() {
    return {
      prop: {
        value: 'code',
        label: 'name',
        children: 'children'
      },
      treeList: [],
      pointerId: [],
      pointerName: [],

    };
  },
  props: ['defaultDataval'],

  created() {
    this.getTree()
    this.pointerId = this.defaultDataval
  },

  methods: {
    getTree() {
      account.get_tree().then(resolve => {
        this.formatTree(resolve)
      })
    },
    // 格式化数据
    formatTree(val) {
      // if (!val[0].children) return;
      let dataList = []
      let formatData = function(data) {
        for (let i = 0; i < data.length; i++) {
          let m = dataList[i] = {}
          let n = data[i].children
          m.name = data[i].name
          m.code = data[i].code
          if (n.length > 0) {
            m.children = []
            for (let j = 0; j < n.length; j++) {
              let o = (m.children)[j] = {}
              let p = n[j].children
              o.name = n[j].name
              o.code = n[j].code
              if (p.length > 0) {
                o.children = []
                for (let k = 0; k < p.length; k++) {
                  let q = (o.children)[k] = {}
                  let r = p[k].children
                  q.name = p[k].name
                  q.code = p[k].code
                }
              }
            }
          }
        }
      }
      formatData(val)
      this.treeList = dataList
    },
    handleChange() {
      this.$emit('change', this.pointerId)
    }
  }
}

</script>
<style lang="css" scoped>


</style>



// WEBPACK FOOTER //
// Datatreeboth.vue?f1cdac86